import React, { FC, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { defineMessages, useIntl } from "react-intl";
import { routes } from "@app/routing";
import { GisIntakeStep, STEP_ROUTE_SUFFIX } from "@app/service/intakeForm";
import { IntakeFormStepLayout } from "../components";
import { useIntakeForm } from "../context";

const messages = defineMessages({
  title: {
    id: "intakeStepActiveDisease.title",
    defaultMessage:
      "Do you currently have active disease or is your cancer in remission?",
  },
  optionActiveDisease: {
    id: "intakeStepActiveDisease.optionActiveDisease",
    defaultMessage: "Active disease",
  },
  optionRemission: {
    id: "intakeStepActiveDisease.optionRemission",
    defaultMessage: "Remission",
  },
  nextButton: {
    id: "intakeStepActiveDisease.nextButton",
    defaultMessage: "Next",
  },
});

const IntakeStepActiveDisease: FC = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { orderUidPublic, testUid } = useParams<{
    orderUidPublic: string;
    testUid: string;
  }>();
  const {
    userInputFields,
    updateUserField,
    totalSteps,
    getNextStep,
    getPreviousStep,
  } = useIntakeForm();

  const currentStep = GisIntakeStep.ACTIVE_DISEASE;
  const [selectedOption, setSelectedOption] = useState<boolean | null>(
    userInputFields.hasActiveDisease
  );

  const buildRoute = (step: GisIntakeStep | null) =>
    routes.scheduleAGeneticInformationSessionIntakePage(
      orderUidPublic || "",
      testUid || ""
    ) + (step ? STEP_ROUTE_SUFFIX[step] : "");

  const handleOptionChange = (value: boolean) => {
    setSelectedOption(value);
    updateUserField("hasActiveDisease", value);
  };

  const handleContinue = () => {
    if (selectedOption === null) return;
    navigate(buildRoute(getNextStep(currentStep)));
  };

  const handleBack = () => {
    navigate(buildRoute(getPreviousStep(currentStep)));
  };

  return (
    <IntakeFormStepLayout
      currentStep={currentStep}
      totalSteps={totalSteps}
      title={intl.formatMessage(messages.title)}
      onContinue={handleContinue}
      onBack={handleBack}
      continueDisabled={selectedOption === null}
      continueLabel={intl.formatMessage(messages.nextButton)}
    >
      <div className="intake-form-step__radio-list">
        <label className="intake-form-step__radio-list__item">
          <input
            type="radio"
            name="active-disease"
            className="intake-form-step__radio-list__input"
            checked={selectedOption === true}
            onChange={() => handleOptionChange(true)}
          />
          <span className="intake-form-step__radio-list__label">
            {intl.formatMessage(messages.optionActiveDisease)}
          </span>
        </label>
        <label className="intake-form-step__radio-list__item">
          <input
            type="radio"
            name="active-disease"
            className="intake-form-step__radio-list__input"
            checked={selectedOption === false}
            onChange={() => handleOptionChange(false)}
          />
          <span className="intake-form-step__radio-list__label">
            {intl.formatMessage(messages.optionRemission)}
          </span>
        </label>
      </div>
    </IntakeFormStepLayout>
  );
};

export default IntakeStepActiveDisease;
